/**
 * Trust strip - regulatory compliance badges shown as a continuous marquee.
 */
const REG = [
  "AMLA — EU Single Rulebook",
  "EU AI Act — Art. 14 Human Oversight",
  "DORA — Operational Resilience",
  "GDPR — by Design",
  "ISO/IEC 27001 — aligned",
  "PSD2 / PSD3 — ready",
  "MiCA — observed",
  "EBA Guidelines — referenced",
];

const TrustStrip = () => {
  const items = [...REG, ...REG];
  return (
    <section
      data-testid="trust-strip"
      className="dark-section border-y border-white/10 py-7 overflow-hidden relative"
    >
      <div className="max-w-[1380px] mx-auto px-6 lg:px-10 mb-5 flex items-center justify-between">
        <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/40">
          Built for —
        </span>
        <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/40">
          Defensible by design
        </span>
      </div>
      <div className="relative">
        <div className="marquee-track flex gap-12 whitespace-nowrap will-change-transform">
          {items.map((label, i) => (
            <span
              key={i}
              className="font-display text-white/75 text-[15px] tracking-tight inline-flex items-center gap-3"
            >
              <span className="w-1 h-1 bg-[#00e5ff]" />
              {label}
            </span>
          ))}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#090a0f] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#090a0f] to-transparent" />
      </div>
    </section>
  );
};

export default TrustStrip;
